import { c as _c } from "react/compiler-runtime";
import { IconButton } from '@repo/design-system/components/ds/button';
import { Icon } from '@repo/design-system/components/ds/icon';
import { Tooltip } from '@repo/design-system/components/ds/tooltip/tooltip';
import { useT } from '@repo/i18n/components/i18n.client';
import { css } from '@repo/panda/css';
import { useAuth } from '@repo/ui-web/auth/auth-hooks';
import { useState } from 'react';
import { MapsAuthModal } from '../components/maps-auth-modal';
import { useCustomPinOperations } from '../game-map/hooks/useCustomPinOperations';
export const AddCustomLocation = () => {
  const $ = _c(29);
  const {
    isAuthenticated
  } = useAuth();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["game_map"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useT(t0);
  const {
    isAddingCustomPin,
    startAddingCustomPin,
    cancelAddingCustomPin
  } = useCustomPinOperations();
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  let t1;
  if ($[1] !== cancelAddingCustomPin || $[2] !== isAddingCustomPin || $[3] !== isAuthenticated || $[4] !== startAddingCustomPin) {
    t1 = async () => {
      if (!isAuthenticated) {
        setIsLoginModalOpen(true);
        return;
      }
      if (isAddingCustomPin) {
        await cancelAddingCustomPin();
      } else {
        await startAddingCustomPin();
      }
    };
    $[1] = cancelAddingCustomPin;
    $[2] = isAddingCustomPin;
    $[3] = isAuthenticated;
    $[4] = startAddingCustomPin;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const handleAddLocation = t1;
  let t2;
  if ($[6] !== t) {
    t2 = t(_temp);
    $[6] = t;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const t3 = isAddingCustomPin ? "black" : "white";
  let t4;
  if ($[8] !== t) {
    t4 = t(_temp2);
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const t5 = isAddingCustomPin ? "purple.600" : "white";
  let t6;
  if ($[10] !== t5) {
    t6 = css({
      background: t5,
      borderRadius: "full",
      "&:not(:focus-visible)": {
        boxShadow: "lg"
      }
    });
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = isAddingCustomPin ? "close" : "add_location_alt";
  let t8;
  if ($[12] !== t7) {
    t8 = <Icon icon={t7} decorative={true} />;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== handleAddLocation || $[15] !== t3 || $[16] !== t4 || $[17] !== t6 || $[18] !== t8) {
    t9 = <IconButton onClick={handleAddLocation} color={t3} size="lg" aria-label={t4} className={t6}>{t8}</IconButton>;
    $[14] = handleAddLocation;
    $[15] = t3;
    $[16] = t4;
    $[17] = t6;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t2 || $[21] !== t9) {
    t10 = <Tooltip content={t2} offset={8} placement="top" size="md">{t9}</Tooltip>;
    $[20] = t2;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = details => setIsLoginModalOpen(details.open);
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== isLoginModalOpen) {
    t12 = <MapsAuthModal isOpen={isLoginModalOpen} onOpenChange={t11} trigger="add-pin" size="sm" />;
    $[24] = isLoginModalOpen;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t10 || $[27] !== t12) {
    t13 = <>{t10}{t12}</>;
    $[26] = t10;
    $[27] = t12;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  return t13;
};
function _temp($) {
  return $.add_custom_location_tooltip;
}
function _temp2($_0) {
  return $_0.add_custom_location;
}